module.exports = __webpack_public_path__ + "media/images/top-3-6cf7aeddbe876e3397efab46df2046fc.png";